module.exports = __webpack_public_path__ + "801422833716a4f0f96ff6dff1f77dfe.jpg";